var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { http } from "../client";
export var createPlaylist = function (playlist) {
    var extra = playlist.type === "public"
        ? { business_types_ids: playlist.businessTypes, image: playlist.image }
        : { client_id: playlist.clientId };
    return http.api
        .post("playlists", __assign({ title: playlist.title, track_ids: playlist.tracks, is_published: playlist.isPublished }, extra))
        .then(function (response) { return ({ id: response.data.data.id }); });
};
